"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TimelineEvent = _interopRequireDefault(require("crm_ui/timeline/components/config/TimelineEvent"));

var _TimelineCard = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCard"));

var _EventTypeRedesignMap = _interopRequireDefault(require("crm_ui/config/EventTypeRedesignMap"));

var _immutable = require("immutable");

var _TimelineEventHelpers = require("crm_ui/timeline/helpers/TimelineEventHelpers");

var TimelineEventContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineEventContainer, _PureComponent);

  function TimelineEventContainer() {
    (0, _classCallCheck2.default)(this, TimelineEventContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineEventContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineEventContainer, [{
    key: "render",
    value: function render() {
      var timelineItem = this.props.timelineItem;
      return _react.default.createElement(_TimelineEvent.default, (0, _extends2.default)({
        TimelineComponent: _TimelineCard.default,
        ChildComponent: (0, _TimelineEventHelpers.getViewType)(_EventTypeRedesignMap.default, timelineItem)
      }, this.props));
    }
  }]);
  return TimelineEventContainer;
}(_PureComponent2.default);

exports.default = TimelineEventContainer;
TimelineEventContainer.propTypes = {
  timelineItem: _propTypes.default.instanceOf(_immutable.Map)
};
module.exports = exports.default;